module.exports = __webpack_public_path__ + "arrow_right.d9ccc77c8240ad0dc272.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/img/svg/arrow_right.svg
// module id = ../../../../../img/svg/arrow_right.svg
// module chunks = styles